module.exports = __webpack_public_path__ + "img/bg.83f23000.png";